import tw, { styled } from 'twin.macro'

export const GoogleReviewsRoot = styled.span`
    ${tw`flex flex-col`}
`
